import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { ProfileSVG, RecycleBinSVG } from '../../../components';
import { Link } from 'react-router-dom';
import { Box, Typography, CircularProgress, Popover } from '@mui/material';
import { makeandcheckerService } from '../../../services';
import { useTranslation } from 'react-i18next';

export default function ClientsMenuDialog ({ dialog, row, onCancel, setDialog, anchorEl }) {
    // Main Component
    const { t } = useTranslation();
    const [isDischarged, setIsDischarged] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setIsLoading(true);
        if (dialog?.client?.status?.description === 'inactive') {
            setIsDischarged(true);
            setIsLoading(false);
        }
        else {
            makeandcheckerService
                .getActions(dialog?.option)
                .then(result => setIsDischarged(!_.isEmpty(result)))
                .then((discharged) => { setIsLoading(false); })
                .catch(e => console.error(e));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Popover open={dialog?.type === 'menu' && row?.id === dialog?.client?.id} onClose={() => setDialog(null)} anchorEl={anchorEl} anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
        }} PaperProps={{ style: { minWidth: '190px', borderRadius: '8px' } }}>
            {(isLoading
                ? <Box display='flex' alignItems='center' justifyContent='center' height='56px' ><CircularProgress size={20} /></Box>
                : <Box
                    display='flex' alignItems='flex-start' justifyContent='center' flexDirection='column'>
                    <Link className="menu_actions--button" to={`/clients/details/${dialog?.client.id}`} style={{ color: '#000000DE', textDecoration: 'none' }} >
                        <ProfileSVG />
                        <Typography variant='h1'>{t('clients.table.menu.viewProfile')}</Typography>
                    </Link>
                    { !isDischarged &&
                        <button className="menu_actions--button" onClick={() => { onCancel(dialog?.client.id); }}
                        ><RecycleBinSVG />
                            <Typography variant='h1'>{t('clients.table.menu.unsubscribe.title')}</Typography>
                        </button>}
                </Box>
            )}
        </Popover>
    );
}
